module.exports = __webpack_public_path__ + "img/code.83f06c33.png";